// menuData.js
const megaMenuData = [
  {
    title: "AGENT FORCE",
    to: "/agentforce", // 🔗 link for title
    icon: "🤖",
    groups: [
      {
        items: [
          { label: "Agentforce", to: "/agentforce", description: "" },
          { label: "Revenue Cloud", to: "/agentforce", description: "" },
          { label: "HLS Cloud", to: "/agentforce", description: "" },
          { label: "Sales Cloud", to: "/agentforce", description: "" },
          { label: "Service Cloud", to: "/agentforce", description: "" },
          { label: "Data Cloud", to: "/agentforce", description: "" },
         
        ],
      },
    ],
  },
  {
    title: "AUTOMATION",
    to: "/automation", // 🔗 link for title
    icon: "⚙️",
    items: [
      { label: "SFMC", to: "/automation", description: "" },
      { label: "Hubspot", to: "/automation", description: "" },
      { label: "Klaviyo", to: "/automation", description: "" },
      { label: "RPA", to: "/automation", description: "" },
      { label: "Testing Automation", to: "/automation", description: "" },
    ],
  },
  {
    title: "Advanced Cloud Services",
    to: "/cloud-services", // 🔗 link for title
    icon: "☁️",
    items: [
      { label: "AWS", to: "/cloud-services", description: "" },
      { label: "Azure", to: "/cloud-services", description: "" },
      { label: "GCP", to: "/cloud-services", description: "" },
    ],
  },
  {
    title: "AI & Data Engineering",
    to: "/ai-data", // 🔗 link for title
    icon: "🧠",
    items: [
      { label: "AI", to: "/ai-data", description: "" },
      { label: "Data Enigineering", to: "/ai-data", description: "" },
    ],
  },
  {
    title: "Advanced DIXAP",
    to: "/dixap", // 🔗 link for title
    icon: "🧩",
    items: [
      { label: "Content Management System", to: "/dixap", description: "" },
      { label: "Customer E-commerce Platform", to: "/dixap", description: "" },
      { label: "Technology", to: "/dixap", description: "" },
      { label: "UI/UX", to: "/dixap", description: "" },
    ],
  },
  {
    title: "Agentic AI",
    to: "/agentic", // 🔗 link for title
    icon: "🦾",
    items: [
      { label: "AI Agents", to: "/agentic", description: "" },
      { label: "AI Chatbot", to: "/agentic", description: "" },
    ],
  },
];

export default megaMenuData;
